/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { ApiAction } from './actions';
import { APIConstants } from './constants';

export type APIState<P> = {
  status: APIConstants;
  data: P;
};

export const initialState = {
  status: APIConstants.UNSTARTED,
  data: [],
};

export function apiReducer<T extends string>(type: T) {
  return (
    state: APIState<any> = initialState,
    action: ApiAction<T>,
  ): APIState<any> => {
    if (action.type === type) {
      switch (action.status) {
        case APIConstants.STARTED:
          return {
            status: action.status,
            data: [],
          };
        case APIConstants.SUCCEEDED:
          return {
            status: action.status,
            data: action.payload,
          };
        case APIConstants.FAILED:
          return {
            status: action.status,
            data: action.payload,
          };
        default:
          return state;
      }
    }
    return state;
  };
}
